import React from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useRef} from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiHeart,FiBrain,FiUsers} = FiIcons;

const USP = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, margin: "-100px"});

  return (
    <section className="py-20 bg-white" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{opacity: 0, y: 50}} 
          animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 50}} 
          transition={{duration: 0.8}} 
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-8">
            Warum K³ für deinen Erfolg wichtig ist:
          </h2>
          <div className="w-24 h-1 bg-azure-600 mx-auto mb-12"></div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <motion.div 
              initial={{opacity: 0, y: 30}} 
              animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 30}} 
              transition={{duration: 0.6, delay: 0.2}} 
              className="text-center"
            >
              <SafeIcon icon={FiHeart} className="text-4xl text-azure-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-3">Kundennähe & Vertrauen</h3>
              <p className="text-gray-700">Wir verstehen die Herausforderungen von KMU und sprechen die Sprache der Unternehmer</p>
            </motion.div>
            
            <motion.div 
              initial={{opacity: 0, y: 30}} 
              animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 30}} 
              transition={{duration: 0.6, delay: 0.4}} 
              className="text-center"
            >
              <SafeIcon icon={FiBrain} className="text-4xl text-azure-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-3">KI-Expertise & Innovation</h3>
              <p className="text-gray-700">Tiefes technisches Verständnis moderner AI-Technologien, einfach und praxisnah erklärt</p>
            </motion.div>
            
            <motion.div 
              initial={{opacity: 0, y: 30}} 
              animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 30}} 
              transition={{duration: 0.6, delay: 0.6}} 
              className="text-center"
            >
              <SafeIcon icon={FiUsers} className="text-4xl text-azure-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-3">Mittelstand & Digitalisierung</h3>
              <p className="text-gray-700">Spezialisiert auf Einzelhandel, KMU und mittelständische Unternehmen in der digitalen Transformation</p>
            </motion.div>
          </div>
          
          <motion.p 
            initial={{opacity: 0, y: 30}} 
            animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 30}} 
            transition={{duration: 0.8, delay: 0.8}} 
            className="text-xl text-gray-700 leading-relaxed"
          >
            Komplexe KI-Technologie wird bei uns zu greifbaren Business-Lösungen. Wir machen Künstliche Intelligenz nicht nur verständlich, sondern zeigen konkret, wie moderne Automatisierung Ihr Geschäft nachhaltig voranbringt.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default USP;